module.exports = __webpack_public_path__ + "static/media/story-14.3a298f84.jpg";